/**
 * @generated SignedSource<<f97fff2b7830855e5490006aef30b5bc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type VerticalType = "art" | "fashion" | "furniture" | "jewelry" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type SbSharedRelatedSellers_creatorRootPage$data = {
  readonly relatedSellers: {
    readonly creatorShopLink: ReadonlyArray<{
      readonly " $fragmentSpreads": FragmentRefs<"SbSharedRelatedSeller_creatorShopLink">;
    }> | null;
    readonly seller: ReadonlyArray<{
      readonly " $fragmentSpreads": FragmentRefs<"SbSharedRelatedSeller_seller" | "sellerBrandingHelpers_seller">;
    } | null> | null;
    readonly storefrontItems: ReadonlyArray<{
      readonly " $fragmentSpreads": FragmentRefs<"SbSharedRelatedSeller_sellerStorefrontItems">;
    } | null> | null;
  } | null;
  readonly verticals: ReadonlyArray<VerticalType | null> | null;
  readonly " $fragmentType": "SbSharedRelatedSellers_creatorRootPage";
};
export type SbSharedRelatedSellers_creatorRootPage$key = {
  readonly " $data"?: SbSharedRelatedSellers_creatorRootPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedRelatedSellers_creatorRootPage">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedRelatedSellers_creatorRootPage",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "verticals",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "RelatedSellers",
      "kind": "LinkedField",
      "name": "relatedSellers",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Seller",
          "kind": "LinkedField",
          "name": "seller",
          "plural": true,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "SbSharedRelatedSeller_seller"
            },
            {
              "kind": "InlineDataFragmentSpread",
              "name": "sellerBrandingHelpers_seller",
              "selections": [
                {
                  "alias": "isRewarded",
                  "args": [
                    {
                      "kind": "Literal",
                      "name": "listNames",
                      "value": [
                        "SELLER_REWARDS_1",
                        "SELLER_REWARDS_2"
                      ]
                    }
                  ],
                  "kind": "ScalarField",
                  "name": "isAnchorListsMember",
                  "storageKey": "isAnchorListsMember(listNames:[\"SELLER_REWARDS_1\",\"SELLER_REWARDS_2\"])"
                }
              ],
              "args": null,
              "argumentDefinitions": []
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "RelatedSellersStorefrontItems",
          "kind": "LinkedField",
          "name": "storefrontItems",
          "plural": true,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "SbSharedRelatedSeller_sellerStorefrontItems"
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "LinkData",
          "kind": "LinkedField",
          "name": "creatorShopLink",
          "plural": true,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "SbSharedRelatedSeller_creatorShopLink"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "CreatorRootPage",
  "abstractKey": null
};

(node as any).hash = "773f4036664f68f11be37d3949899d93";

export default node;
